import {
  AdvanceNavIcon,
  CVUNavIcon,
  CreditCardNavIcon,
  FireMembership,
  HamburgerNavIcon,
  HomeNavIcon,
  MovementNavIcon,
  ProfileNavIcon,
  ConfigNavIcon,
  LogoutNavIcon,
  DialogNavIcon
} from 'assets/icons'

export const PRIMARY_NAV = [
  {
    Icon: HomeNavIcon,
    text: 'Inicio',
    id: 'home'
  },
  {
    Icon: MovementNavIcon,
    text: 'Movimientos',
    id: 'movimientos'
  },
  {
    Icon: AdvanceNavIcon,
    text: 'Wayni Crédito',
    id: 'wayni-credito'
  },
  {
    Icon: CreditCardNavIcon,
    text: 'Tarjetas',
    id: 'mis-tarjetas'
  }
]

export const HAMBURGUER_BUTTON = {
  Icon: HamburgerNavIcon,
  text: 'Menú',
  id: 'menu'
}

export const LOGOUT_BUTTON = {
  Icon: LogoutNavIcon,
  text: 'Cerrar sesión',
  id: 'logout'
}

export const MEMBERSHIP_BUTTON = {
  Icon: FireMembership,
  text: (
    <span>
      Mi Wayni<span className='text-green-800 font-bold'>+</span>
    </span>
  ),
  id: 'suscripcion'
}

export const SECONDARY_NAV = [
  {
    Icon: ProfileNavIcon,
    text: 'Mis datos',
    id: 'mis-datos'
  },
  {
    Icon: CVUNavIcon,
    text: 'Mi CVU',
    id: 'cvu'
  },
  {
    Icon: ConfigNavIcon,
    text: 'Configuración',
    id: 'configuracion'
  },
  {
    Icon: DialogNavIcon,
    text: 'Centro de ayuda',
    id: 'centro-de-ayuda',
    event: 'bille_boton_centro_de_ayuda'
  }
]
